<template>
  <div>
    <label>{{ $t("filter.titles." + key) }}</label>
    <b-input-group>
      <b-input-group-text>
        <font-awesome-icon :icon="icon" />
      </b-input-group-text>

      <b-form-select
        v-model="selected"
        :options="options"
        @input="transmitNewValue()"
      >
        <template #first>
          <b-form-select-option :value="selected" disabled>{{
            $t("filter.year")
          }}</b-form-select-option>
        </template>
      </b-form-select>
    </b-input-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    default: { type: Number, default: null }
  },
  data() {
    return {
      selected: null,
      icon: "calendar-alt",
      key: "year"
    };
  },
  mounted() {
    this.getDefaultYear();
    this.transmitNewValue();
  },
  computed: {
    ...mapGetters('years', ['years'])
  },
  methods: {
    getDefaultYear() {
      this.selected = this.default ? this.default : 0;
    },
    transmitNewValue() {
      this.$emit("transmit", this.selected, this.key);
    }
  }
};
</script>
